var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9709 12.024C19.1962 12.024 20.9999 10.2279 20.9999 8.012C20.9999 5.79605 19.1962 4 16.9709 4C14.7465 4 12.9428 5.79605 12.9428 8.012C12.9428 9.0388 13.4111 9.7851 13.4111 9.7851L8.5398 14.6369C8.32135 14.8545 8.01535 15.4206 8.5398 15.9433L9.10165 16.5026C9.3201 16.6896 9.87005 16.9506 10.3197 16.5026L10.975 15.8498C11.6312 16.5026 12.3809 16.1295 12.6614 15.7563C13.1306 15.1035 12.5679 14.4499 12.5679 14.4499L12.7549 14.2629C13.6551 15.1588 14.4422 14.6369 14.7227 14.2629C15.191 13.6101 14.7227 12.9573 14.7227 12.9573C14.5357 12.5833 14.1608 12.5833 14.6292 12.1175L15.191 11.5573C15.6415 11.9313 16.5655 12.0248 16.9718 12.0248L16.9709 12.024Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.0441C20.9456 17.419 20.7195 18.8062 19.7709 19.7539C18.5248 21 16.5205 21 12.5085 21C8.4965 21 6.4922 21 5.2461 19.7539C4 18.5078 4 16.5035 4 12.4915C4 8.4795 4 6.4752 5.2461 5.2291C6.193 4.2805 7.58105 4.0544 9.95595 4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPermission);
export default __webpack_public_path__ + "static/media/UserPermission.f595b0a338c74ae28a1ee7f8085d960b.svg";
export { ForwardRef as ReactComponent };